import {
  ACTIVITIES_WHATSAPP_GROUPS,
  WEEKLY_SESSION_DISCUSSIONS,
  WEEKLY_SESSION_SESSIONS_HREF,
  ZOOM_ROOM,
} from "../../content/activities";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Card } from "../../ui/Card";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/**
 * The old site's `/weekly-session`: the WhatsApp group button, a single
 * Zoom button, the two Sunday discussion cards, then a single link to past
 * sessions. English only - the old site had no Hindi rendering of this
 * page.
 *
 * The old page showed two duplicate "Joining Zoom ID" buttons whose
 * displayed ID ("89436021905") did not match the room the link itself
 * opened (`zoom.us/j/383310813`). This page shows one button, reading its
 * ID from the same `ZOOM_ROOM` constant as its href, so the number shown
 * can never disagree with the room it opens.
 */
export function WeeklySessionPage() {
  return (
    <Page title="Weekly Session" heading="Weekly Session">
      <Section>
        <div className="flex flex-wrap gap-3">
          {ACTIVITIES_WHATSAPP_GROUPS.map((group) => (
            <Button
              key={group.href}
              href={group.href}
              external
              variant="secondary"
            >
              {group.suffix
                ? `${t("en", "whatsappGroup")} (${group.suffix})`
                : t("en", "whatsappGroup")}
            </Button>
          ))}
          <Button href={ZOOM_ROOM.href} external variant="secondary">
            {t("en", "joinOnZoom")}
            <span className="font-normal opacity-70">{ZOOM_ROOM.id}</span>
          </Button>
        </div>
        <div className="mt-8 grid max-w-3xl gap-6 sm:grid-cols-2">
          {WEEKLY_SESSION_DISCUSSIONS.map((discussion) => (
            <Reveal key={discussion.title}>
              <Card title={discussion.title}>
                <p>{discussion.basis}</p>
                <p className="mt-1">{discussion.schedule}</p>
              </Card>
            </Reveal>
          ))}
        </div>
        <div className="mt-8">
          <Button href={WEEKLY_SESSION_SESSIONS_HREF} variant="secondary">
            View Past Sessions
          </Button>
        </div>
      </Section>
    </Page>
  );
}
